module.exports = __webpack_public_path__ + "img/jd.53fcdfe2.png";